import { createContext } from "react";

import {
  defaultDictionary,
  SpellCheckDictionary,
} from "../core/account/dictionaries";

export const SpellCheckContext =
  createContext<SpellCheckDictionary>(defaultDictionary);
